export default __webpack_public_path__ + "static/media/based_telegrame.fe47d6af.svg";